import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Esto funciona si estoy amamantando?',
    a: 'Sí. La guía está diseñada para mamás que amamantan y para mamás que usan fórmula. El sistema trabaja con las asociaciones de sueño — no contra la lactancia. El Capítulo 03 explica específicamente cómo separar gradualmente la alimentación del proceso de dormirse sin eliminar las tomas nocturnas que tu bebé todavía necesita.'
  }, {
    q: '¿Mi bebé tiene solo 3 semanas — ¿es muy temprano para empezar?',
    a: 'No es demasiado temprano para empezar a crear las condiciones adecuadas. Los primeros capítulos de la guía están diseñados específicamente para las primeras semanas — sin rutinas rígidas, sin expectativas irreales, con estrategias adaptadas a lo que un recién nacido puede y no puede hacer.'
  }, {
    q: '¿Funciona si el bebé tiene cólicos o reflujo?',
    a: 'El Capítulo 07 aborda específicamente los factores médicos que pueden estar bloqueando el sueño. Si hay un componente médico presente — la guía te ayuda a identificarlo y te orienta sobre cuándo y cómo trabajar el sueño en paralelo al tratamiento médico.'
  }, {
    q: '¿Cuánto tiempo tengo que dedicarle al día?',
    a: 'La guía está diseñada para mamás que no tienen tiempo ni energía de sobra. Cada lámina es concisa y accionable. Puedes leer un capítulo completo en 15-20 minutos. Y las estrategias se aplican dentro de tu rutina diaria — no son actividades adicionales.'
  }, {
    q: '¿Qué pasa si tengo pareja que trabaja en turno de noche o no tengo apoyo?',
    a: 'El sistema está diseñado para funcionar aunque seas la única persona disponible. Las estrategias del Capítulo 06 incluyen específicamente herramientas para mamás sin red de apoyo inmediata.'
  }, {
    q: 'Ya compré otro libro de sueño y no funcionó. ¿Por qué este sería diferente?',
    a: 'Porque la mayoría de los libros de sueño infantil en español son traducciones de metodologías anglosajones sin adaptación cultural. Porque ninguno adapta las estrategias semana a semana por edad exacta. Y porque ninguno incluye el componente del bienestar de la mamá como parte central del sistema — no como apéndice. Si llegaste hasta aquí leyendo esta carta — ya notaste la diferencia.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white py-24 px-6" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <FadeIn data-id="element-105">
          <h2 className="text-3xl md:text-4xl font-bold text-azul-noche mb-12 text-center" data-id="element-106">
            Preguntas frecuentes — respuestas honestas
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-107">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 + index * 0.1} data-id="element-108">
              <div className="border border-gray-200 rounded-xl overflow-hidden bg-white" data-id="element-109">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none hover:bg-crema/10 transition-colors" data-id="element-110">
                  <div className="flex items-center gap-4 pr-4" data-id="element-111">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B2A4A" strokeWidth="2" className="flex-shrink-0" data-id="element-112">
                      <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" data-id="element-113" />
                    </svg>
                    <span className="font-bold text-azul-noche text-lg" data-id="element-114">
                      {faq.q}
                    </span>
                  </div>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="flex-shrink-0" data-id="element-115">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1B2A4A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-116">
                      <polyline points="6 9 12 15 18 9" data-id="element-117"></polyline>
                    </svg>
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-118">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-119">
                      <div className="p-6 pt-0 text-texto text-lg border-t border-gray-100 mt-2" data-id="element-120">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}